import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { createOrder } from "../redux/Actions/OrderActions";
import { ORDER_CREATE_RESET } from "../redux/Constants/OrderConstants";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import { formatNumber, getDistanceKm, rateUsdt, tinhGiaShipSoKm } from "../service";

const PlaceOrderScreen = ({ history }) => {
  window.scrollTo(0, 0);

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [taxPrice, setTaxPrice] = useState(0);

  const addDecimals = (num) => (Math.round(num * 100) / 100).toFixed(2);

  cart.itemsPrice = addDecimals(
    cart.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0)
  );

  cart.shippingPrice = 0;
  // addDecimals(
  //   cart.itemsPrice > 100
  //     ? cart.itemsPrice > 200
  //       ? cart.itemsPrice > 300
  //         ? 0
  //         : 5
  //       : 10
  //     : 15
  // );

  // Tính taxPrice dựa trên khoảng cách
  useEffect(() => {
    const fetchTax = async () => {
      try {
        console.log(cart.shippingAddress);

        const km = await getDistanceKm(cart.shippingAddress.address.replace(cart.shippingAddress.saveData.address, ''));
        const fee = await tinhGiaShipSoKm(km + 1.5);
        if (window.localStorage.getItem('paymentMethod') == 'now') {
          setTaxPrice(fee / (rateUsdt * 2));
        } else {
          setTaxPrice(fee / (rateUsdt));
        }

      } catch (err) {
        console.error(err);
        setTaxPrice(0);
      }
    };
    fetchTax();
  }, [cart]);

  cart.taxPrice = taxPrice;

  cart.totalPrice = (
    Number(cart.itemsPrice) +
    Number(cart.shippingPrice) +
    (Number(cart.taxPrice))
  ).toFixed(2);

  const orderCreate = useSelector((state) => state.orderCreate);
  const { order, success, error } = orderCreate;

  useEffect(() => {
    if (success) {
      history.push(`/order/${order._id}`);
      dispatch({ type: ORDER_CREATE_RESET });
    }
  }, [history, dispatch, success, order]);

  const placeOrderHandler = () => {

    dispatch(
      createOrder({
        orderItems: cart.cartItems,
        shippingAddress: cart.shippingAddress,
        paymentMethod: cart.paymentMethod || window.localStorage.getItem('paymentMethod'),
        itemsPrice: cart.itemsPrice,
        shippingPrice: cart.shippingPrice,
        taxPrice: cart.taxPrice,
        totalPrice: cart.totalPrice,
      })
    );
  };

  return (
    <>
      <Header />
      <div className="container">
        <div className="row  order-detail">
          {/* 1. Thông tin khách hàng */}
          <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
            <div className="row ">
              <div className="col-md-4 center">
                <div className="alert-success order-box">
                  <i className="fas fa-user"></i>
                </div>
              </div>
              <div className="col-md-8 center">
                <h5>
                  <strong>Khách hàng</strong>
                </h5>
                <p>{userInfo?.name || 'none'}</p>
                <p>{userInfo?.email || 'none'}</p>
              </div>
            </div>
          </div>

          {/* 2. Thông tin đơn hàng */}
          <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
            <div className="row">
              <div className="col-md-4 center">
                <div className="alert-success order-box">
                  <i className="fas fa-truck-moving"></i>
                </div>
              </div>
              <div className="col-md-8 center">
                <h5>
                  <strong>Thông tin đơn hàng</strong>
                </h5>
                <p>Vận chuyển: VN</p>
                <p>Thanh toán: {window.localStorage.getItem('paymentMethod') == 'now' ? "Online" : (window.localStorage.getItem('paymentMethod') == 'point' ? "Điểm" : "Khi nhận hàng")}</p>
              </div>
            </div>
          </div>

          {/* 3. Địa chỉ giao hàng */}
          <div className="col-lg-4 col-sm-4 mb-lg-4 mb-5 mb-sm-0">
            <div className="row">
              <div className="col-md-4 center">
                <div className="alert-success order-box">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
              </div>
              <div className="col-md-8 center">
                <h5>
                  <strong>Giao tới</strong>
                </h5>
                <p>
                  Địa chỉ: {cart.shippingAddress.city},{" "}
                  {cart.shippingAddress.address},{" "}
                  {cart.shippingAddress.postalCode}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Danh sách sản phẩm */}
        <div className="row order-products justify-content-between">
          <div className="col-lg-8">
            {cart.cartItems.length === 0 ? (
              <Message variant="alert-info mt-5">Giỏ hàng trống</Message>
            ) : (
              <>
                {cart?.cartItems?.map((item, index) => (
                  <div className="order-product row" key={index}>
                    <div className="col-md-3 col-6">
                      <img src={item.image.url} alt={item.name} />
                    </div>
                    <div className="col-md-5 col-6 d-flex align-items-center">
                      <Link to={`/products/${item.product}`}>
                        <h6>{item.name}</h6>
                      </Link>
                    </div>
                    <div className="mt-3 mt-md-0 col-md-2 col-6 d-flex align-items-center flex-column justify-content-center ">
                      <h4>SỐ LƯỢNG</h4>
                      <h6>{item.qty}</h6>
                    </div>
                    <div className="mt-3 mt-md-0 col-md-2 col-6 align-items-end d-flex flex-column justify-content-center ">
                      <h4>TẠM TÍNH</h4>
                      <h6>
                        <img src="/images/logoToken.png" style={{ width: 20 }} /> {formatNumber(item.qty * item.price)} <span className="oojjsdfges">({formatNumber(item.qty * item.price * rateUsdt)}đ)</span>
                      </h6>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>

          {/* Tổng tiền */}
          <div className="col-lg-3 d-flex align-items-end flex-column mt-5 subtotal-order">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>
                    <strong>Sản phẩm</strong>
                  </td>
                  <td><img src="/images/logoToken.png" style={{ width: 20 }} /> {cart.itemsPrice} <span className="oojjsdfges">({formatNumber(cart.itemsPrice * rateUsdt)}đ)</span></td>
                </tr>
                <tr>
                  <td>
                    <strong>Phí vận chuyển</strong>
                  </td>
                  <td><img src="/images/logoToken.png" style={{ width: 20 }} /> {
                    window.localStorage.getItem('paymentMethod') == 'now'
                      ?
                      <>
                        <span style={{ textDecoration: 'line-through', fontSize: 15 }}>{((Number(cart.shippingPrice) + Number(cart.taxPrice) * 2)).toFixed(2)}</span> {((Number(cart.shippingPrice) + Number(cart.taxPrice))).toFixed(2)}

                      </>
                      :
                      (Number(cart.shippingPrice) + Number(cart.taxPrice)).toFixed(2)
                  }</td>
                </tr>
                {/* <tr>
                  <td>
                    <strong>Thuế</strong>
                  </td>
                  <td><img src="/images/logoToken.png" style={{ width: 20 }} /> {cart.taxPrice}</td>
                </tr> */}
                <tr>
                  <td>
                    <strong>Tổng cộng</strong>
                  </td>
                  <td><img src="/images/logoToken.png" style={{ width: 20 }} /> {cart.totalPrice} <span className="oojjsdfges">({formatNumber(cart.totalPrice * rateUsdt)}đ)</span></td>
                </tr>
              </tbody>
            </table>
            {cart.cartItems.length === 0 ? null : (
              <button type="submit" disabled={(Number(cart.shippingPrice) + Number(cart.taxPrice)) <= 0} onClick={placeOrderHandler}>
                ĐẶT HÀNG
              </button>
            )}
            {error && (
              <div className="my-3 col-12">
                <Message variant="alert-danger">{error}</Message>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default PlaceOrderScreen;
